export const BASIC_QUESTIONS = [
  {
    id: 'qc_1',
    text: 'What is 15 × 12?',
    category: 'Quick Challenge',
    correct_answer: '180',
  },
  {
    id: 'qc_gen_1',
    text: 'What is 5 + 7?',
    category: 'Quick Challenge',
    correct_answer: '12',
  },
  {
    id: 'qc_2',
    text: 'What is the square root of 144?',
    category: 'Quick Challenge',
    grade_level: '2A-3C',
    correct_answer: '12',
  },
  {
    id: 'qc_3',
    text: 'What is 25% of 80?',
    category: 'Quick Challenge',
    grade_level: '2A-3C',
    correct_answer: '20',
  },
  {
    id: 'qc_4',
    text: 'What is 7 × 8?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '56',
  },
  {
    id: 'qc_5',
    text: 'What is 144 ÷ 12?',
    category: 'Quick Challenge',
    grade_level: '2A-3C',
    correct_answer: '12',
  },
  {
    id: 'qc_6',
    text: 'What is 9 × 7?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '63',
  },
  {
    id: 'qc_7',
    text: 'What is 16 × 5?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '80',
  },
  {
    id: 'qc_8',
    text: 'What is 3 × 9?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '27',
  },
  {
    id: 'qc_9',
    text: 'What is 6 × 6?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '36',
  },
  {
    id: 'qc_10',
    text: 'What is 4 × 8?',
    category: 'Quick Challenge',
    grade_level: '1A-3C',
    correct_answer: '32',
  },
  {
    id: 'fm_1',
    text: 'A train travels 60 km in 45 minutes. What is its speed in km/h?',
    category: 'FactMath',
    grade_level: '2A-3C',
    correct_answer: '80',
  },
  {
    id: 'fm_2',
    text: 'What is the area of a circle with radius 5cm? (Use π = 3.14)',
    category: 'FactMath',
    grade_level: '3A-3C',
    correct_answer: '78.5',
  },
  {
    id: 'fm_3',
    text: '15% of 200 = ?',
    category: 'FactMath',
    grade_level: '2A-3C',
    correct_answer: '30',
  },
  {
    id: 'fm_4',
    text: 'What is the perimeter of a square with side length 8cm?',
    category: 'FactMath',
    grade_level: '2A-3C',
    correct_answer: '32',
  },
  {
    id: 'fm_5',
    text: 'If 3x + 7 = 22, what is x?',
    category: 'FactMath',
    grade_level: '3A-3C',
    correct_answer: '5',
  },
  {
    id: 'fc_1',
    text: "What's 25% of 80? 🧠",
    category: 'Fun Challenge',
    grade_level: '2A-3C',
    correct_answer: '20',
  },
  {
    id: 'fc_2',
    text: 'If you have 24 apples and eat 8, how many are left?',
    category: 'Fun Challenge',
    grade_level: '1A-2C',
    correct_answer: '16',
  },
  {
    id: 'fc_3',
    text: 'A pizza is cut into 8 slices. You eat 3 slices. What fraction is left?',
    category: 'Fun Challenge',
    grade_level: '2A-3C',
    correct_answer: '5/8',
  },
  {
    id: 'fc_4',
    text: 'What is 12 + 15 + 18?',
    category: 'Fun Challenge',
    grade_level: '1A-2C',
    correct_answer: '45',
  },
  {
    id: 'fc_5',
    text: 'If a rectangle has length 10cm and width 6cm, what is its area?',
    category: 'Fun Challenge',
    grade_level: '2A-3C',
    correct_answer: '60',
  },
  {
    id: 'fc_6',
    text: 'Choose the even number',
    category: 'Fun Challenge',
    options: ['11', '14', '17', '19'],
    correct_answer: '14',
  },
];
